import {createContext, useContext, useState} from "react";

export interface Language {
    languageCode: string;
    englishName: string;
    localName: string;
    flagEmoji: string;
}

export const LANGUAGES: Language[] = [
    { languageCode: 'en', englishName: 'English', localName: 'English', flagEmoji: '🇬🇧' },
    { languageCode: 'pl', englishName: 'Polish', localName: 'Polski', flagEmoji: '🇵🇱' },
    { languageCode: 'ro', englishName: 'Romanian', localName: 'Română', flagEmoji: '🇷🇴' },
    { languageCode: 'bg', englishName: 'Bulgarian', localName: 'Български', flagEmoji: '🇧🇬' },
    { languageCode: 'pt', englishName: 'Portuguese', localName: 'Português', flagEmoji: '🇵🇹' },
    { languageCode: 'lt', englishName: 'Lithuanian', localName: 'Lietuvių', flagEmoji: '🇱🇹' },
    { languageCode: 'es', englishName: 'Spanish', localName: 'Español', flagEmoji: '🇪🇸' },
    { languageCode: 'ru', englishName: 'Russian', localName: 'Русский', flagEmoji: '🇷🇺' },
    { languageCode: 'uk', englishName: 'Ukrainian', localName: 'Українська', flagEmoji: '🇺🇦' },
    { languageCode: 'lv', englishName: 'Latvian', localName: 'Latviešu', flagEmoji: '🇱🇻' },
    { languageCode: 'hu', englishName: 'Hungarian', localName: 'Magyar', flagEmoji: '🇭🇺' },
    { languageCode: 'sk', englishName: 'Slovak', localName: 'Slovenčina', flagEmoji: '🇸🇰' },
    { languageCode: 'cs', englishName: 'Czech', localName: 'Čeština', flagEmoji: '🇨🇿' },
    { languageCode: 'it', englishName: 'Italian', localName: 'Italiano', flagEmoji: '🇮🇹' },
    { languageCode: 'el', englishName: 'Greek', localName: 'Ελληνικά', flagEmoji: '🇬🇷' },
    { languageCode: 'hr', englishName: 'Croatian', localName: 'Hrvatski', flagEmoji: '🇭🇷' },
    { languageCode: 'sr', englishName: 'Serbian', localName: 'Српски', flagEmoji: '🇷🇸' },
    { languageCode: 'bs', englishName: 'Bosnian', localName: 'Bosanski', flagEmoji: '🇧🇦' },
    { languageCode: 'fr', englishName: 'French', localName: 'Français', flagEmoji: '🇫🇷' },
    { languageCode: 'tr', englishName: 'Turkish', localName: 'Türkçe', flagEmoji: '🇹🇷' },
    { languageCode: 'ar', englishName: 'Arabic', localName: 'العربية', flagEmoji: '🇸🇦' },
    { languageCode: 'hi', englishName: 'Hindi', localName: 'हिन्दी', flagEmoji: '🇮🇳' },
    { languageCode: 'ur', englishName: 'Urdu', localName: 'اردو', flagEmoji: '🇵🇰' },
    { languageCode: 'ta', englishName: 'Tamil', localName: 'தமிழ்', flagEmoji: '🇱🇰' },
    { languageCode: 'ne', englishName: 'Nepali', localName: 'नेपाली', flagEmoji: '🇳🇵' },
    { languageCode: 'zh', englishName: 'Chinese', localName: '中文', flagEmoji: '🇨🇳' },
    { languageCode: 'vi', englishName: 'Vietnamese', localName: 'Tiếng Việt', flagEmoji: '🇻🇳' },
    { languageCode: 'th', englishName: 'Thai', localName: 'ไทย', flagEmoji: '🇹🇭' },
    { languageCode: 'fa', englishName: 'Persian (Farsi)', localName: 'فارسی', flagEmoji: '🇮🇷' },
    { languageCode: 'id', englishName: 'Indonesian', localName: 'Bahasa Indonesia', flagEmoji: '🇮🇩' },
    { languageCode: 'ms', englishName: 'Malay', localName: 'Bahasa Melayu', flagEmoji: '🇲🇾' },
    { languageCode: 'sw', englishName: 'Swahili', localName: 'Kiswahili', flagEmoji: '🇰🇪' },
    { languageCode: 'be', englishName: 'Belarusian', localName: 'Беларуская', flagEmoji: '🇧🇾' },
    { languageCode: 'mk', englishName: 'Macedonian', localName: 'Македонски', flagEmoji: '🇲🇰' },
    { languageCode: 'sl', englishName: 'Slovenian', localName: 'Slovenščina', flagEmoji: '🇸🇮' },
    { languageCode: 'az', englishName: 'Azerbaijani', localName: 'Azərbaycan', flagEmoji: '🇦🇿' },
    { languageCode: 'hy', englishName: 'Armenian', localName: 'Հայերեն', flagEmoji: '🇦🇲' },
    { languageCode: 'kk', englishName: 'Kazakh', localName: 'Қазақ', flagEmoji: '🇰🇿' },
    { languageCode: 'tg', englishName: 'Tajik', localName: 'Тоҷикӣ', flagEmoji: '🇹🇯' },
    { languageCode: 'et', englishName: 'Estonian', localName: 'Eesti', flagEmoji: '🇪🇪' },
    { languageCode: 'da', englishName: 'Danish', localName: 'Dansk', flagEmoji: '🇩🇰' },
    { languageCode: 'de', englishName: 'German', localName: 'Deutsch', flagEmoji: '🇩🇪' },
    { languageCode: 'nl', englishName: 'Dutch', localName: 'Nederlands', flagEmoji: '🇳🇱' },
    { languageCode: 'sv', englishName: 'Swedish', localName: 'Svenska', flagEmoji: '🇸🇪' },
    { languageCode: 'no', englishName: 'Norwegian', localName: 'Norsk', flagEmoji: '🇳🇴' },
    { languageCode: 'fi', englishName: 'Finnish', localName: 'Suomi', flagEmoji: '🇫🇮' },
    { languageCode: 'af', englishName: 'Afrikaans', localName: 'Afrikaans', flagEmoji: '🇿🇦' },
    { languageCode: 'ca', englishName: 'Catalan', localName: 'Català', flagEmoji: '🇪🇸' },
    { languageCode: 'gl', englishName: 'Galician', localName: 'Galego', flagEmoji: '🇪🇸' },
    { languageCode: 'he', englishName: 'Hebrew', localName: 'עברית', flagEmoji: '🇮🇱' },
    { languageCode: 'kn', englishName: 'Kannada', localName: 'ಕನ್ನಡ', flagEmoji: '🇮🇳' },
    { languageCode: 'mr', englishName: 'Marathi', localName: 'मराठी', flagEmoji: '🇮🇳' },
    { languageCode: 'ko', englishName: 'Korean', localName: '한국어', flagEmoji: '🇰🇷' },
    { languageCode: 'ja', englishName: 'Japanese', localName: '日本語', flagEmoji: '🇯🇵' },
    { languageCode: 'is', englishName: 'Icelandic', localName: 'Íslenska', flagEmoji: '🇮🇸' },
    { languageCode: 'mi', englishName: 'Māori', localName: 'Māori', flagEmoji: '🇳🇿' },
    { languageCode: 'cy', englishName: 'Welsh', localName: 'Cymraeg', flagEmoji: '🇬🇧' },
].sort((a, b) => a.localName.localeCompare(b.localName))

const ENGLISH: Language = { languageCode: 'en', englishName: 'English', localName: 'English', flagEmoji: '🇬🇧' };

export interface LanguageContextType {
    language: Language
    setLanguage: (languageCode: string) => void;
}

export const LanguageContext = createContext<LanguageContextType>(null as any)

const chooseDefaultLanguageCode = () => {
    // Check local storage first
    const languageCode = localStorage.getItem('languageCode');
    if (languageCode) {
        return languageCode;
    }

    // Check browser language
    const browserLanguageCode = navigator.language.split('-')[0];
    if (browserLanguageCode && LANGUAGES.find(language => language.languageCode === browserLanguageCode)) {
        return browserLanguageCode;
    }

    // Default to English
    return 'en';
}

const setLocalStorageLanguageCode = (languageCode: string) => localStorage.setItem('languageCode', languageCode);

export const useNewLanguageContext = (): LanguageContextType => {
    const [languageCode, setLanguageCode] = useState<string>(chooseDefaultLanguageCode);

    const language = LANGUAGES.find(language => language.languageCode === languageCode) ?? ENGLISH

    const setLanguage = (languageCode: string) => {
        setLanguageCode(languageCode);
        setLocalStorageLanguageCode(languageCode);
    }

    return {language, setLanguage}
}

export const useLanguage = (): Language => useContext(LanguageContext).language